import '@/shared/i18n/i18n';
import React from 'react'
import ReactDOM from 'react-dom/client'
import { appAnalytics } from '@/shared/analytics'
import App from './app'
import './index.css'

const installBrowserZoomPrevention = () => {
  const preventGestureZoom = (event: Event) => {
    event.preventDefault()
  }

  const preventCtrlOrMetaWheelZoom = (event: WheelEvent) => {
    if (event.ctrlKey || event.metaKey) {
      event.preventDefault()
    }
  }

  const preventCtrlOrMetaKeyZoom = (event: KeyboardEvent) => {
    if (!(event.ctrlKey || event.metaKey)) {
      return
    }
    if (event.key === '+' || event.key === '-' || event.key === '=' || event.key === '0') {
      event.preventDefault()
    }
  }

  const preventPinchZoom = (event: TouchEvent) => {
    if (event.touches.length > 1) {
      event.preventDefault()
    }
  }

  let lastTouchEndAt = 0
  const preventDoubleTapZoom = (event: TouchEvent) => {
    const now = Date.now()
    if (now - lastTouchEndAt <= 300) {
      event.preventDefault()
    }
    lastTouchEndAt = now
  }

  document.addEventListener('gesturestart', preventGestureZoom, { passive: false })
  document.addEventListener('gesturechange', preventGestureZoom, { passive: false })
  document.addEventListener('gestureend', preventGestureZoom, { passive: false })
  document.addEventListener('touchmove', preventPinchZoom, { passive: false })
  document.addEventListener('touchend', preventDoubleTapZoom, { passive: false })
  window.addEventListener('wheel', preventCtrlOrMetaWheelZoom, { passive: false, capture: true })
  window.addEventListener('keydown', preventCtrlOrMetaKeyZoom, { capture: true })
}

installBrowserZoomPrevention()
appAnalytics.bootstrap()

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
